import LastModified from './LastModified'

export default LastModified
